import { UsersApi , AuthenticatorSetupDataDto } from "@green0meter/api-client";
import { redirect } from "react-router-dom";

import { Error } from "@helpers";

export const MFAFormLoader = async (): Promise<
  AuthenticatorSetupDataDto | Response
> => {
  const api = new UsersApi(undefined, import.meta.env.VITE_API_BASE_URL);

  try {
    const qr = await api.usersControllerGenerateMfaAuthenticatorQr();

    return qr.data;
  } catch (error) {
    Error(error);

    return redirect("/login");
  }
};
